import { createCustomEnum } from "./customEnum";

const CreditCardTypes = createCustomEnum({
	Unknown: {
		value: 0,
		name: "unknown",
		displayName: "",
	},
	Visa: {
		value: 1,
		name: "visa",
		displayName: "Visa",
	},
	MasterCard: {
		value: 2,
		name: "master_card",
		displayName: "MasterCard",
	},
	AmericanExpress: {
		value: 3,
		name: "american_express",
		displayName: "American Express",
	},

	Discover: {
		value: 4,
		name: "discover",
		displayName: "Discover",
	},
	Diners: {
		value: 5,
		name: "diners_club",
		displayName: "Diners",
	},
	Jcb: {
		value: 6,
		name: "jcb",
		displayName: "JCB",
	},
	ChinaUnionPay: {
		value: 7,
		name: "chinaUnionPay",
		displayName: "China UnionPay",
	},
});

export default CreditCardTypes;
